import { cloneDeep, filter, map, includes } from 'lodash';

import { NODE_TYPES } from '../api/Tasks/taskConstants';

import Graph from './GraphClass';

class Task extends Graph {
  getSubTasks() {
    const topoSortedSubTasks = filter(this.topoSortedVertices, ['nodeType', NODE_TYPES.SUBTASK]);
    const topoSortedSubTasksIds = map(topoSortedSubTasks, vertex => vertex.id);
    const sortedTasks = filter(this.vertices, vertex => includes(topoSortedSubTasksIds, vertex.id));
    return cloneDeep(sortedTasks);
  }

  getConnections() {
    const topoSortedConnections = filter(this.topoSortedVertices, [
      'nodeType',
      NODE_TYPES.CONNECTION
    ]);
    const topoSortedConnectionIds = map(topoSortedConnections, vertex => vertex.id);
    const sortedTasks = filter(this.vertices, vertex =>
      includes(topoSortedConnectionIds, vertex.id)
    );
    return cloneDeep(sortedTasks);
  }
}

export default Task;
